import React from "react";
import { formatRupiah } from "../../../../../utils/helper";
import { DiscountIcon } from "../../../../../utils/svg";
import Footer from "../../../../../components/Footer";

const SummaryFooter = ({
  cart = null,
  isShowBottomSheet = false,
  isShowWarningVoucher = false,
  isShowWarningRedeem = false,
  isLoading = false,
  isLoadingDeliveryList = false,
  isLoadingVoucherList = false,
  isLoadingPaymentMethodList = false,
  paymentSummary = {},
  handleSubmit = () => {}
}) => {
  if (
    !cart ||
    isShowBottomSheet ||
    isShowWarningVoucher ||
    isShowWarningRedeem
  ) {
    return null;
  }

  return (
    <Footer position="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-lg" id="cart" className="!z-[6]">
      <div
        className={`bg-white p-4 shadow-custom transition-transform duration-1000 ease-in-out ${cart ? "translate-y-0 relative" : "translate-y-full hidden"}`}
      >
        <div className="items-center hidden">
          <DiscountIcon />
          <div className="pl-2 text-gray-900 text-xs">
            Yay, kamu menghemat 10k. Tambahkan lebih banyak dan hemat
            hingga 50k!
          </div>
        </div>
        <button
          id="summary_pay_and_order"
          type="button"
          disabled={
            isLoading ||
            isLoadingDeliveryList ||
            isLoadingVoucherList ||
            isLoadingPaymentMethodList ||
            !paymentSummary.totalPayment
          }
          className={`${
            isLoading ||
            isLoadingDeliveryList ||
            isLoadingVoucherList ||
            isLoadingPaymentMethodList ||
            !paymentSummary.totalPayment
              ? "bg-gray-300 text-white"
              : "bg-[var(--rose-violet)] text-white"
          } mt-2 w-full flex justify-between font-normal text-sm p-3 items-center border-0`}
          onClick={() => handleSubmit()}
        >
          <div>Bayar dan Pesan</div>
          <div>
            {formatRupiah(parseInt(paymentSummary?.totalPayment || 0))}
          </div>
        </button>
      </div>
    </Footer>
  );
};

export default SummaryFooter;
